import {Routes} from "@angular/router";
import {HomeComponent} from "./components/home/home.component";
import {AuthGuardService} from "./authentication-guard/auth-guard.service";
import {SignupComponent} from "./components/signup/signup.component";
import {ArtistsComponent} from "./components/artists/artists.component";
import {AlbumsComponent} from "./components/albums/albums.component";
import {FolderTagsComponent} from "./components/folder-tags/folder-tags.component";
import {NotFoundPageComponent} from "./components/not-found-page/not-found-page.component";

export const APPROUTES: Routes = [
  { path: '',
    component: HomeComponent,
    canActivate: [AuthGuardService],
    children: [
      { path: '', redirectTo: 'artists', pathMatch: 'full', canActivate: [AuthGuardService] },
      { path: 'artists', component: ArtistsComponent, canActivate: [AuthGuardService] },
      { path: 'artists/:tagId', component: ArtistsComponent, canActivate: [AuthGuardService] },
      { path: 'artists/folder/:folderId', component: FolderTagsComponent, canActivate: [AuthGuardService] },
      { path: 'albums', component: AlbumsComponent, canActivate: [AuthGuardService] },
      { path: 'albums/:tagId', component: AlbumsComponent, canActivate: [AuthGuardService] },
      { path: 'albums/folder/:folderId', component: FolderTagsComponent, canActivate: [AuthGuardService] }]
  },
  { path: 'signup', component: SignupComponent },
  { path: '404', component: NotFoundPageComponent },
  { path: '**', pathMatch: 'full', component: NotFoundPageComponent}
];
